import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect, useRef, useState } from 'react';

type UseAutoAddToFavoritesProps = {
    sku: string | undefined;
    userId: string | undefined;
    isFavorite: boolean | undefined;
    isFavoritesLoading: boolean;
    isTogglePending: boolean;
    toggleFavorite: (params: { sku: string; action: 'add' }) => void;
};

export const useAutoAddToFavorites = ({
    sku,
    userId,
    isFavorite,
    isFavoritesLoading,
    isTogglePending,
    toggleFavorite,
}: UseAutoAddToFavoritesProps) => {
    const searchParams = useSearchParams();
    const pathname = usePathname();

    const addAfterLoginRef = useRef(false);
    const [wishlistSkuFromUrl, setWishlistSkuFromUrl] = useState<string | null>(null);

    useEffect(() => {
        const wishlistParam = searchParams?.get('wishlist');

        if (wishlistParam) {
            window.history.replaceState(null, '', pathname);
            setWishlistSkuFromUrl(wishlistParam);
        }
    }, [pathname, searchParams]);

    useEffect(() => {
        if (!userId || !sku || isFavorite || isFavoritesLoading || isTogglePending) return;

        if (addAfterLoginRef.current || wishlistSkuFromUrl === sku) {
            toggleFavorite({ sku, action: 'add' });
            addAfterLoginRef.current = false;
            setWishlistSkuFromUrl(null);
        }
    }, [userId, sku, isFavorite, isFavoritesLoading, isTogglePending, wishlistSkuFromUrl, toggleFavorite]);

    const triggerAddAfterLogin = () => {
        addAfterLoginRef.current = true;
    };

    return { triggerAddAfterLogin };
};
